export const HistoryTypeEnum = {
    'QUESTION_OR_SERIE': 'QUESTION_OR_SERIE',
    'PARCOURS': 'PARCOURS'
};
